export default __webpack_public_path__ + "static/media/Cropimg.b3d420db.jpg";